import {createAction, props} from "@ngrx/store";
import {HomeIdInterface} from "../../interfaces/home.interface";

const homeId = '[HOME]';

export const homeSaveIdAction = createAction(`${homeId} ID Saved`, props<HomeIdInterface>());
